import { HttpContextToken } from '@angular/common/http';

/** Default request timeout (ms) applied by HttpLoadingInterceptor to `/api` calls. */
export const DEFAULT_HTTP_TIMEOUT_MS = 30_000;

/**
 * Per-request timeout (in ms) honoured by HttpLoadingInterceptor. Requests that
 * don't set it fall back to {@link DEFAULT_HTTP_TIMEOUT_MS}. Long-running calls
 * (e.g. Foundry agent chat) set a higher value via the request's HttpContext.
 */
export const HTTP_TIMEOUT_MS = new HttpContextToken<number>(() => DEFAULT_HTTP_TIMEOUT_MS);
